<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            School Years
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="ml-3 mr-3 my-2" v-on="on">
                  <v-icon left>mdi-calendar</v-icon>Add SchoolYear
                </v-btn>
              </template>

              <v-form ref="form" lazy-validation>
                <v-card>
                  <v-card-title>{{ formTitle }}</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="9">
                          <v-text-field
                            v-model="editedItem.description"
                            label="Description"
                            :counter="50"
                            :rules="descriptionRules"
                            :disabled="editedIndex !== -1"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                          <v-checkbox
                            v-model="editedItem.isTheoreticalExamsOnly"
                            label="Is Theoretical Exams Only?"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-menu
                            ref="startDateMenu"
                            v-model="startDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.registrationStartDate"
                                label="Registration Start Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="editedItem.registrationStartDate"
                              min="2003-01-01"
                              @change="saveStartDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-menu
                            ref="lateDateMenu"
                            v-model="lateDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.lateFeeDate"
                                label="Late Fee Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="editedItem.lateFeeDate"
                              min="2003-01-01"
                              @change="saveLateDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-menu
                            ref="endDateMenu"
                            v-model="endDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.registrationEndDate"
                                label="Registration End Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="editedItem.registrationEndDate"
                              min="2003-01-01"
                              @change="saveEndDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-menu
                            ref="releaseDateMenu"
                            v-model="releaseDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.finalGradeReleaseDate"
                                label="Final Grade Release Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="editedItem.finalGradeReleaseDate"
                              min="2003-01-01"
                              @change="saveReleaseDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
            <ReturnHomeBtn />
          </v-card-title>
          <v-data-table
            :loading="!schoolYears"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="schoolYears"
          >
            <template v-slot:item.description="{ item }">
              <v-chip
                :color="(schoolYear && schoolYear.id == item.id) ? 'primary' : 'secondary'"
              >{{ item.description }}</v-chip>
            </template>

            <template
              v-slot:item.registrationStartDate="{ item }"
            >{{ item.registrationStartDate | formatDate }}</template>
            <template v-slot:item.lateFeeDate="{ item }">{{ item.lateFeeDate | formatDate }}</template>
            <template
              v-slot:item.registrationEndDate="{ item }"
            >{{ item.registrationEndDate | formatDate }}</template>
            <template
              v-slot:item.finalGradeReleaseDate="{ item }"
            >{{ item.finalGradeReleaseDate | formatDate }}</template>

            <template v-slot:item.isTheoreticalExamsOnly="{ item }">
              <v-simple-checkbox v-model="item.isTheoreticalExamsOnly" disabled></v-simple-checkbox>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-layout :justify-end="true">
                <v-icon v-if="item.examRegistrationCount === 0" @click="deleteItem(item)">mdi-delete</v-icon>
                <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessageMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";

export default {
  name: "SchoolYears",
  mixins: [errorMessageMixin],
  components: { ReturnHomeBtn },
  async created() {
    await this.loadSchoolYears();
  },
  data() {
    return {
      headers: [
        { text: "Description", value: "description", align: "start" },
        { text: "Start Date", value: "registrationStartDate" },
        { text: "Late Fee Date", value: "lateFeeDate" },
        { text: "End Date", value: "registrationEndDate" },
        { text: "Grade Release Date", value: "finalGradeReleaseDate" },
        { text: "Theory Only", value: "isTheoreticalExamsOnly" },
        { text: "Registrations", value: "examRegistrationCount" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        description: "",
        registrationStartDate: new Date().getFullYear() + "-03-01",
        lateFeeDate: new Date().getFullYear() + "-06-01",
        registrationEndDate: new Date().getFullYear() + "-07-01",
        finalGradeReleaseDate: new Date().getFullYear() + "-08-01",
        isTheoreticalExamsOnly: false
      },
      dialog: false,
      startDateMenu: false,
      lateDateMenu: false,
      endDateMenu: false,
      releaseDateMenu: false,
      descriptionRules: [
        v => !!v || "Description is required.",
        v =>
          (v && v.length <= 50) ||
          "Description name must be less than 50 characters"
      ]
    };
  },
  computed: {
    ...mapState(["schoolYears", "schoolYear"]),
    formTitle() {
      return this.editedIndex === -1 ? "Add SchoolYear" : "Edit SchoolYear";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    ...mapActions([
      "getSchoolYearsAction",
      "logout",
      "updateSchoolYearAction",
      "addSchoolYearAction",
      "deleteSchoolYearAction"
    ]),
    async loadSchoolYears() {
      try {
        await this.getSchoolYearsAction();
        if (this.$store.state.schoolYears == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    async deleteItem(item) {
      console.log("im in delete", item);
      if (confirm("Remove " + item.description + "?")) {
        this.$store.state.fullScreenLoading = true;
        const deleteSchoolYearModel = {
          accountId: this.$store.state.user.id,
          schoolYearId: item.id
        };
        try {
          await this.deleteSchoolYearAction({
            model: deleteSchoolYearModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("delete done");
        } catch (err) {
          console.log("im in error");
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        console.log("after the try");
        this.$store.state.fullScreenLoading = false;
      }
    },
    editItem(item) {
      console.log("im in edit", item);
      this.editedIndex = this.schoolYears.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedItem.registrationStartDate = this.editedItem.registrationStartDate.substr(
        0,
        10
      );
      this.editedItem.lateFeeDate = this.editedItem.lateFeeDate.substr(0, 10);
      this.editedItem.registrationEndDate = this.editedItem.registrationEndDate.substr(
        0,
        10
      );
      this.editedItem.finalGradeReleaseDate = this.editedItem.finalGradeReleaseDate.substr(
        0,
        10
      );

      console.log("this.editedItem", this.editedItem);
      this.dialog = true;
    },
    saveStartDate(date) {
      this.$refs.startDateMenu.save(date);
    },
    saveLateDate(date) {
      this.$refs.lateDateMenu.save(date);
    },
    saveEndDate(date) {
      this.$refs.endDateMenu.save(date);
    },
    saveReleaseDate(date) {
      this.$refs.releaseDateMenu.save(date);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async save() {
      console.log("updte with this.editedItem", this.editedItem);
      if (!this.$refs.form.validate()) {
        return;
      }
      console.log("im valid");

      if (this.editedIndex > -1) {
        try {
          const model = {
            adminId: this.$store.state.user.id,
            id: this.editedItem.id,
            registrationStartDate: this.editedItem.registrationStartDate,
            lateFeeDate: this.editedItem.lateFeeDate,
            registrationEndDate: this.editedItem.registrationEndDate,
            finalGradeReleaseDate: this.editedItem.finalGradeReleaseDate,
            isTheoreticalExamsOnly: this.editedItem.isTheoreticalExamsOnly
          };

          await this.updateSchoolYearAction({
            model: model,
            token: this.$store.state.token
          });
          this.close();
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
      } else {
        try {
          const model = {
            adminId: this.$store.state.user.id,
            description: this.editedItem.description,
            registrationStartDate: this.editedItem.registrationStartDate,
            lateFeeDate: this.editedItem.lateFeeDate,
            registrationEndDate: this.editedItem.registrationEndDate,
            finalGradeReleaseDate: this.editedItem.finalGradeReleaseDate,
            isTheoreticalExamsOnly: this.editedItem.isTheoreticalExamsOnly
          };

          await this.addSchoolYearAction({
            model: model,
            token: this.$store.state.token
          });
          this.close();
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
      }
    }
  }
};
</script>
